import React from 'react';
import './ChipsFilter.scss';
import PropTypes from 'prop-types';

const ChipFilter = ({ options, selected, onToggle }) => {
  return (
    <div className="chip-filter">
      {options.map((opt) => {
        const isActive = selected.includes(opt.value);
        return (
          <button
            key={opt.value}
            className={`chip ${isActive ? 'chip--active' : ''}`}
            onClick={() => onToggle(opt.value)}
          >
            {isActive ? (
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="chip-check"
              >
                <circle cx="12" cy="12" r="12" fill="#1A1A1A" />
                <path
                  d="M7 12L10.5 15.5L18 8"
                  stroke="white"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            ) : (
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="chip-check"
              >
                <circle cx="12" cy="12" r="11" stroke="#DDDDDD" strokeWidth="2" fill="white" />
              </svg>
            )}
            <span className="chip-text">{opt.label}</span>
          </button>
        );
      })}
    </div>
  );
};

ChipFilter.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  selected: PropTypes.arrayOf(PropTypes.string).isRequired,
  onToggle: PropTypes.func.isRequired
};

export default ChipFilter;
